/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PrintLocationQrCodeRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {PrintLocationQrCodeResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const printLocationQrCode = (request: PrintLocationQrCodeRequest, options?: CashRequestOptions) => post<PrintLocationQrCodeRequest, PrintLocationQrCodeResponse>("/2.0/cash/print-location-qr-code", request, {...options, rejectOnError: true })